import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconClipboard2"><Path fillRule="evenodd" clipRule="evenodd" d="M16.95 4H18.5C19.8807 4 21 5.11929 21 6.5V19.5C21 20.8807 19.8807 22 18.5 22H5.5C4.11929 22 3 20.8807 3 19.5V6.5C3 5.11929 4.11929 4 5.5 4H7.05001C7.28164 2.85888 8.29052 2 9.5 2H14.5C15.7095 2 16.7184 2.85888 16.95 4ZM16 4.5C16 3.67157 15.3284 3 14.5 3H9.5C8.67157 3 8 3.67157 8 4.5V5.5C8 5.77614 8.22386 6 8.5 6H15.5C15.7761 6 16 5.77614 16 5.5V4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconClipboard2;
